const getApiUrl = () => {
  const { hostname } = window.location;

  if (hostname.includes('localhost')) {
    return 'http://localhost:8089/v1/xml-morpher';
  }

  const apiHostname = hostname.replace('xml-morpher', 'api');
  return `https://${apiHostname}/v1/xml-morpher`;
};

export const baseUrl = getApiUrl();
export const useMock = process.env.REACT_APP_BACKEND_USE_MOCK;
export const mockUserToken = process.env.REACT_APP_MOCK_USER_TOKEN;
